function handleError(error, vm) {
    console.log('ErrorService: ' + error + ' ' + vm);
}

window.onerror = function (message, source, lineno, colno, error) {
    console.log('window error: ' + message + ' ' + source + ' ' + lineno + ' ' + colno + ' ' + error);
};

export default handleError;